import { Team__Aliados } from "./teams/Aliados";
import { Team__Cerveceros_MAIN } from "./teams/Cerveceros_MAIN";
import { Team__Chiles } from "./teams/Chiles";
import { Team__MeanMachine } from "./teams/MeanMachine";
import { Team__Raptors } from "./teams/Raptors";
import { Team__Tec } from "./teams/Tec";
import { Team__XLobos } from "./teams/XLobos";

export const teamList_old_men_first = [
  Team__Tec,
  Team__Aliados,
  Team__Cerveceros_MAIN,
  Team__Chiles,
  Team__MeanMachine,
  Team__XLobos,
  Team__Raptors,
];
